const supplierRoutes = [

    {
        path: '/suppliers',
        name: 'suppliers',
        component: () => import('@/views/supplier/Suppliers')
    },
    {
        path: '/suppliers/:id',
        name: 'supplier',
        component: () => import('@/views/supplier/Supplier'),
        props: route => {
            const id = Number.parseInt(route.params.id, 10);
            if (Number.isNaN(id)) {
                return 0;
            }
            return {id};
        }
    },
    {
        path: '/suppliers/:id/edit',
        name: 'supplierEdit',
        component: () => import('@/views/supplier/SupplierEdit'),
        props: route => {
            const id = Number.parseInt(route.params.id, 10);
            if (Number.isNaN(id)) {
                return 0;
            }
            return {id};
        }
    },
    {
        path: '/suppliers/create',
        name: 'supplierCreate',
        component: () => import('@/views/supplier/SupplierEdit')
    },
]
export default supplierRoutes